/**
 * Moderna 1273 COVID-19 Vaccine Study - Self-Contained Module
 *
 * This module contains all configuration for the Moderna 1273 COVID-19 Vaccine Study
 * in a single, easily maintainable location.
 */

import { defineStudy } from "./registry";
import { moderna1273EligibleZipCodes } from "../../../data/vaccine-study-zipcodes/moderna1273ZipCodes";
import { moderna1273ScreeningQuestions } from "../../../data/pre-screener-config/Moderna1273Screener";

/**
 * Common question IDs that will be asked before zipcode
 * and should be filtered out of study-specific questions
 */
const COMMON_QUESTION_IDS = ["age_eligibility", "past_vaccine_study_participation"];

/**
 * Moderna 1273 COVID-19 Vaccine Study
 *
 * Priority: 4 (Fourth priority - after Cidara 65+, Seqirus, and Cidara 18+)
 * Trial ID: VMODCOV19P40365
 * Location: Specific zipcodes (320 total)
 *
 * Key criteria:
 * - Age 65+
 * - Willing to receive COVID-19 vaccine
 * - No COVID infection in past 6 months
 * - No COVID vaccine in past 6 months
 * - Not immunocompromised
 * - No recent heart inflammation
 * - No history of Guillain-Barré syndrome
 */
export const moderna1273CovidStudy = defineStudy({
  id: "moderna-1273-covid",
  name: "Moderna COVID-19 Vaccine Study",
  trialId: "VMODCOV19P40365",
  priority: 4,

  // Convert readonly array to regular array for compatibility
  eligibleZipCodes: Array.from(moderna1273EligibleZipCodes),

  // All questions including common ones (will be filtered automatically)
  questions: moderna1273ScreeningQuestions,

  // Questions to filter out (already asked in common stage)
  commonQuestionIds: COMMON_QUESTION_IDS,

  // Required common answer values (age 65+)
  commonAnswerRequirements: {
    age_eligibility: ["65_or_older"],
  },

  metadata: {
    sponsor: "Moderna",
    description:
      "Investigating an investigational COVID-19 vaccine designed to target newer variants in adults aged 65 and older",
  },
});
